var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"icon - chevron left - 24px"},[React.createElement("path",{"style":{"fill":"none"},"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"data-name":"↳color","d":"m-20536-14171-4 4 4 4","transform":"translate(20549.998 14178.999)","style":{"stroke":"#031425","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5px","fill":"none"},"key":1})]));
}

ChevronLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
